export default __webpack_public_path__ + "static/media/failure-mobile-illustration.86a9e107.svg";